import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-large);
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	grid-template-rows: auto;
	grid-template-areas:
		'primaryTeamHeader separator emptyMessage'
		'primaryTeamTable separator emptyMessage'
		'primaryTeamTable separator emptyMessage';
	gap: var(--gap);
	padding: var(--accordion-padding-v) var(--accordion-padding-h);
	align-items: start;
	width: 100%;
	&.mapped {
		grid-template-areas:
			'primaryTeamHeader separator firstMappedName'
			'primaryTeamTable separator firstMappedTable'
			'primaryTeamTable separator restMapped';
	}
	&.commented {
		grid-template-areas:
			'primaryTeamHeader separator emptyMessage'
			'primaryTeamTable separator emptyMessage'
			'primaryTeamTable separator emptyMessage'
			'commentArea commentArea commentArea';
		&.mapped {
			grid-template-areas:
				'primaryTeamHeader separator firstMappedName'
				'primaryTeamTable separator firstMappedTable'
				'primaryTeamTable separator restMapped'
				'commentArea commentArea commentArea';
		}
	}

	.comment-wrapper {
		grid-area: commentArea;
		display: flex;
		flex-direction: column;
		gap: inherit;
	}

	.primary-header {
		grid-area: primaryTeamHeader;
		display: flex;
		flex-direction: column;
		gap: inherit;
	}

	.primary-table {
		grid-area: primaryTeamTable;
	}

	.empty-message {
		grid-area: emptyMessage;
		align-self: normal;
	}

	.separator {
		grid-area: separator;
		align-self: normal;
	}

	.first-component-header {
		grid-area: firstMappedName;
		display: flex;
		flex-direction: column;
		gap: inherit;
		min-width: 0;
	}

	.first-component-table {
		grid-area: firstMappedTable;
	}

	.rest-component-risks {
		grid-area: restMapped;
		display: flex;
		flex-direction: column;
		gap: inherit;
	}
`;
